import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { PrivacyData as PrivacyDataDefault } from '../components/Footer/constants';
import { useTranslation } from 'react-i18next';


const usePrivacyFooter = () => {
  const { t } = useTranslation('footer');
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  const [privacyConfig, setPrivacyConfig] = React.useState<typeof PrivacyDataDefault | []>([]);
  
  const isGeneralConfigEmpty = Object.keys(generalConfig).length === 0;

  useEffect(() => {
    if(isGeneralConfigEmpty) return;
    const dataPrivacy = generalConfig?.dataPrivacy ?? [];

      setPrivacyConfig(dataPrivacy);
  }, [isGeneralConfigEmpty, generalConfig]);

  const dataPrivacy = privacyConfig.map(
    (item: typeof PrivacyDataDefault[0]) => {
      return item.path
      ? {
            ...item,
            title: t(`footer:${item.title}`),
        }
      : {};
  });

  return {
    dataPrivacy,
  }

};

export default usePrivacyFooter;
